import { getJwtToken } from "@web-src/features/auth/utils";
import store from "@web-src/store";
import { logout } from "@web-src/features/auth/authSlice";
import { getAxiosInstance } from "@jugl-web/rest-api";
import { environment } from "@web-src/environments/environment";
import { anonymousSessionState } from "@web-src/modules/auth/providers/AnonymousSessionProvider/anonymousSessionState";
import { rateLimitEvents } from "./rateLimitEvents";

const api = getAxiosInstance(
  () => getJwtToken()?.accessToken,
  environment.apiUrl,
  environment.isDemo
);

api.interceptors.response.use(undefined, (error) => {
  if (error?.response?.status === 401) {
    if (!anonymousSessionState.isAnonymous) {
      store.dispatch(logout());
    }
  }
  if (
    error?.response?.status === 429 &&
    !error?.config?.url?.includes("/anonymous_session")
  ) {
    rateLimitEvents.emit(
      anonymousSessionState.isAnonymous ? "anonymous" : "authenticated"
    );
  }
  throw error;
});

export default api;
